import React from "react";
import clsx from "clsx";
import Footer from "./Footer/Footer";

type Props = {
	children: React.ReactNode;
	className?: string;
};

const PageLayout = ({ className, children }: Props) => (
	<div className={clsx("bg-white", className)}>
		<div className="min-h-[calc(100vh-180px)]">{children}</div>
		<Footer />
	</div>
);

export default PageLayout;
